export const Data = [
  {
    question: "What is Event Planning?",
    answer:
      "The concept of planning and executing an organised event, such as a conference, business event, corporate activity, or special event, is identified as event planning. From determining the event's intent to identifying target audience, choosing a location, managing catering, promotions, and incorporating technological strategies to post-event surveys and reports.",
  },
  {
    question: "Why event management?",
    answer:
      "Event managers plan and organise promotional, business and social events. They're responsible for running a range of events, ensuring the target audience is engaged and the message of the event is marketed properly. Events play a huge part in the success of a brand or an organisation. Hiring an event manager saves your time and energy. Why to take stress if SKYLARK is here to take yours. Just sit back, relax and let us plan an event that SMILES back 😊.",
  },
  {
    question: "Where do we operate?",
    answer:
      "We operate PAN India and our office is in Kolkata, Delhi and Bokaro.",
  },
  {
    question: "What are our services?",
    answer:
      "We provide end to end service such as tenting, sound, light, Decor, dining, transportation, guest speakers, event monitoring, photography etc. We do any thing that is required for an event. If you consider us to work together, we will either find a way, or make one!!!",
  },
  {
    question: "What types of events do we plan?",
    answer:
      "Our main focus categories are wedding, destination weddings and corporate events. Apart from these we plan b'day parties, concerts, Destination Wedding, Corporate Event, Haldi, Mehndi, First Night Decor etc.",
  },
  {
    question:
      "Do I Have to Go Through Your Vendors If I Hire You as My Planner/Designer?",
    answer:
      "No, you don't. SKYLARK will take care of this. You have to sit back and relax and get ready for the event that SMILES back :)",
  },
  {
    question: "Why do we need an Event Planner?",
    answer:
      "Event managers plan and organise promotional, business and social events. They're responsible for running a range of events, ensuring the target audience is engaged and the message of the event is marketed properly. Events play a huge part in the success of a brand or an organisation. Hiring an event manager saves your time and energy. Why to take stress if SKYLARK is here to take yours. Just sit back, relax and let us plan an event that SMILES back ",
  },
  {
    question: "Do you charge separately?",
    answer:
      "Yes, every service has different charges. Fill out the inquiry form and you will get the details.",
  },
  {
    question: "Do You Provide Last Minute Event Management Services?",
    answer: "Yes, absolutely",
  },
  {
    question: "What are the minimum and maximum budgets?",
    answer:
      "It starts from 3 lac and goes to Infinity. It totally depends on your requirement. Budget varies on the basis of location, size of the venue, requirements and availability of the elements involved",
  },
  {
    question: "Can you arrange celebrities like  Ranveer Singh?",
    answer: "Yes, we arrange celebrity guests as well",
  },
  {
    question:
      "Can you plan an event in foreign countries like Thailand or Bali?",
    answer:
      "Yes, we operate overseas as well, let us know the requirements and just sit back and relax.",
  },
];
